import { FC, useMemo } from 'react';
import x1Aerosol from '../../images/packaging/1x/packaging-aerosol-1x.png';
import x1AirPump from '../../images/packaging/1x/packaging-air-pump-1x.png';
import x1Bag from '../../images/packaging/1x/packaging-bag-1x.png';
import x1BagInCan from '../../images/packaging/1x/packaging-bag-in-can-1x.png';
import x1Bottle from '../../images/packaging/1x/packaging-bottle-1x.png';
import x1Carton from '../../images/packaging/1x/packaging-carton-1x.png';
import x1Compact from '../../images/packaging/1x/packaging-compact-1x.png';
import x1Jar from '../../images/packaging/1x/packaging-jar-1x.png';
import x1JarBottle from '../../images/packaging/1x/packaging-jar-bottle-1x.png';
import x1PumpDispenser from '../../images/packaging/1x/packaging-pump-dispenser-1x.png';
import x1Sachet from '../../images/packaging/1x/packaging-sachet-1x.png';
import x1Tube from '../../images/packaging/1x/packaging-tube-1x.png';
import x2Aerosol from '../../images/packaging/2x/packaging-aerosol-2x.png';
import x2AirPump from '../../images/packaging/2x/packaging-air-pump-2x.png';
import x2Bag from '../../images/packaging/2x/packaging-bag-2x.png';
import x2BagInCan from '../../images/packaging/2x/packaging-bag-in-can-2x.png';
import x2Bottle from '../../images/packaging/2x/packaging-bottle-2x.png';
import x2Carton from '../../images/packaging/2x/packaging-carton-2x.png';
import x2Compact from '../../images/packaging/2x/packaging-compact-2x.png';
import x2Jar from '../../images/packaging/2x/packaging-jar-2x.png';
import x2JarBottle from '../../images/packaging/2x/packaging-jar-bottle-2x.png';
import x2PumpDispenser from '../../images/packaging/2x/packaging-pump-dispenser-2x.png';
import x2Sachet from '../../images/packaging/2x/packaging-sachet-2x.png';
import x2Tube from '../../images/packaging/2x/packaging-tube-2x.png';

export type PackagingImageProps = {
  packagingValue: string;
  packagingName: string;
  isBig?: boolean;
  flexJustify?:
    | 'justify-start'
    | 'justify-around'
    | 'justify-between'
    | 'justify-end'
    | 'justify-center'
    | 'justify-evenly';
};

export const PackagingImage: FC<PackagingImageProps> = ({
  packagingValue,
  packagingName,
  isBig,
  flexJustify,
}: PackagingImageProps) => {
  const [Img1x, Img2x] = useMemo(() => {
    switch (packagingValue) {
      case 'pump-dispenser':
        return [x1PumpDispenser, x2PumpDispenser];
      case 'jar':
        return [x1Jar, x2Jar];
      case 'tube':
        return [x1Tube, x2Tube];
      case 'aerosol':
        return [x1Aerosol, x2Aerosol];
      case 'sachet':
        return [x1Sachet, x2Sachet];
      case 'bag-in-can':
        return [x1BagInCan, x2BagInCan];
      case 'spray-dispenser':
      case 'air-pump':
        return [x1AirPump, x2AirPump];
      case 'bag':
        return [x1Bag, x2Bag];
      case 'carton':
        return [x1Carton, x2Carton];
      case 'bottle':
        return [x1Bottle, x2Bottle];
      case 'compact':
        return [x1Compact, x2Compact];
      case 'jar-bottle':
        return [x1JarBottle, x2JarBottle];
      case 'other':
      default:
        return ['', ''];
    }
  }, [packagingValue]);

  return Img1x && Img2x ? (
    <div
      data-testid="testPackagingImage"
      className={`flex ${flexJustify ? flexJustify : 'justify-center'}`}
    >
      <img
        className={`${isBig ? `max-h-96` : 'max-h-24 min-w-14'}`}
        alt={packagingName}
        src={Img1x}
        srcSet={`${Img1x} 1x, ${Img2x} 2x`}
      />
    </div>
  ) : null;
};
